/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetClusterInviteInfoRequest = {
  token: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/**
 * Invite metadata
 */
export type GetClusterInviteInfoResponseBody = {
  email: string | null;
  suggestedOrgName: string | null;
  expiresAt: string;
};

/** @internal */
export const GetClusterInviteInfoRequest$inboundSchema: z.ZodType<
  GetClusterInviteInfoRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  token: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetClusterInviteInfoRequest$Outbound = {
  token: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetClusterInviteInfoRequest$outboundSchema: z.ZodType<
  GetClusterInviteInfoRequest$Outbound,
  z.ZodTypeDef,
  GetClusterInviteInfoRequest
> = z.object({
  token: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getClusterInviteInfoRequestToJSON(
  getClusterInviteInfoRequest: GetClusterInviteInfoRequest,
): string {
  return JSON.stringify(
    GetClusterInviteInfoRequest$outboundSchema.parse(
      getClusterInviteInfoRequest,
    ),
  );
}
export function getClusterInviteInfoRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetClusterInviteInfoRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetClusterInviteInfoRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetClusterInviteInfoRequest' from JSON`,
  );
}

/** @internal */
export const GetClusterInviteInfoResponseBody$inboundSchema: z.ZodType<
  GetClusterInviteInfoResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  email: z.nullable(z.string()),
  suggestedOrgName: z.nullable(z.string()),
  expiresAt: z.string(),
});
/** @internal */
export type GetClusterInviteInfoResponseBody$Outbound = {
  email: string | null;
  suggestedOrgName: string | null;
  expiresAt: string;
};

/** @internal */
export const GetClusterInviteInfoResponseBody$outboundSchema: z.ZodType<
  GetClusterInviteInfoResponseBody$Outbound,
  z.ZodTypeDef,
  GetClusterInviteInfoResponseBody
> = z.object({
  email: z.nullable(z.string()),
  suggestedOrgName: z.nullable(z.string()),
  expiresAt: z.string(),
});

export function getClusterInviteInfoResponseBodyToJSON(
  getClusterInviteInfoResponseBody: GetClusterInviteInfoResponseBody,
): string {
  return JSON.stringify(
    GetClusterInviteInfoResponseBody$outboundSchema.parse(
      getClusterInviteInfoResponseBody,
    ),
  );
}
export function getClusterInviteInfoResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetClusterInviteInfoResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetClusterInviteInfoResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetClusterInviteInfoResponseBody' from JSON`,
  );
}
